import React, { useEffect, useContext, useState } from "react";

const FlagChips = (props) => {

    return <div className="fg-wrap">
        {(props.selectedFlags || []).map(
            (flag, i) => <div key={i} className=" fg-each-chip">
                {flag.tag_display_name}
            </div>
        )}
    </div>
}

export default FlagChips;